var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project container"},[_c('div',{staticClass:"content"},[_c('p',{directives:[{name:"scroll-reveal",rawName:"v-scroll-reveal"}]},[_vm._v("\n      Get started\n    ")]),_c('h3',{directives:[{name:"scroll-reveal",rawName:"v-scroll-reveal",value:({ delay: 100 }),expression:"{ delay: 100 }"}]},[_vm._v("\n      Do you have a project in mind?"),_c('br'),_vm._v("Here are a few things we could help\n      you with.\n    ")]),_c('h2',{directives:[{name:"scroll-reveal",rawName:"v-scroll-reveal",value:({ delay: 200 }),expression:"{ delay: 200 }"}]},[_c('vue-typer',{attrs:{"shuffle":true,"text":[
          'Move to headless',
          'Get started with PWA',
          'Expand to a new market',
          'Increase performance',
          'Increase conversion',
          'Re-think your design',
          'Integrate your ERP',
          'Run A/B tests',
          'Migrate your old platform',
          'Perform user tests',
          'Sell more',
          'Get into China',
          'Remove bottlenecks',
          'Plan for the future',
          'Lower costs',
          'Support your team',
          'Improve your CMS',
          'Run benchmark tests'
        ]}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }